import HeaderSection from '../../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../../components/CockpitCards/CardTransparent';


export default function PharmaGenesText() {

    
    return (

    <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Your" 
            headline_grey = "Pharmacogenetic Profile "
            headline_p2 = "for Drugs"

            text1 = "This section summarizes 23 key genes, known as PGx genes, that play a critical role in how your body processes medications. For each gene, your specific genotype is shown alongside the corresponding enzyme activity, or phenotype. Together, these insights help predicting how effectively your body may metabolize certain drugs."
            text2 = "Next to each gene, you'll find a list of drugs which metabolism is known to be influenced by this gene. This serves as a foundation for the personalized recommendations provided in the Medication Guide, where drug-specific guidance is offered based on established clinical guidelines.​"
            text3 = "Understanding your genetic profile is an important step toward more informed and personalized medication decisions. We encourage you to share these results with your doctor, healthcare provider or pharmacist to support your ongoing treatment plan. For explanations of the terms and classifications used in this table, please refer to the 'Important Read' tab."

            />
    }/>
            
  )
}